(function () {
	var trackerId = document.getElementById('trackerId');
	var fStatus;
	var statusMessage = document.querySelector('.report-generation__status-message');

	function checkStatus() {
		statusMessage.innerHTML = 'Checking...';
		var xmlhttp = new XMLHttpRequest();
		var url = 'status?id=' + trackerId.value;

		xmlhttp.onreadystatechange = function () {
			if (this.status === 404) {
				document.getElementById('content').innerHTML += 'No ongoing parsing or parsing finished!';
				stop();
			}
			else if (this.readyState === 4 && this.status === 200) {
				var myArr = JSON.parse(this.responseText);
				parseStatusResponse(myArr);
			}
		};
		xmlhttp.open('GET', url, true);
		xmlhttp.send();
	}

	function parseStatusResponse(json) {
		setTimeout(function() {
			statusMessage.innerHTML = 'Parsing...';
		}, 1500);

		var out = '<table>';
		var i;
		var date;
		var lastLogMessage;
		var progressValue = (json.ActionsDone / json.TotalActions) * 100;

		document.getElementById('progress').value = progressValue;
		for (i = 0; i < json.Log.length; i++) {
			date = getDateFromAspNetFormat(json.Log[i].Item1);
			out +=
				'<tr>' +
				'<td>' + date.toLocaleTimeString('en-GB') + ' - </td>' +
				'<td>' + json.Log[i].Item2 + '</td>' +
				'</tr>';

			lastLogMessage = json.Log[i].Item2;
		}

		var contentArea = document.getElementById('content');
		contentArea.innerHTML = out;
		contentArea.scrollTop = contentArea.scrollHeight;

		if (progressValue >= 100) {
			stop();
			date = new Date(Date.now());
			out += '<tr><td>' + date.toLocaleTimeString('en-GB') + ' - </td><td>Done</td></tr>';

			document.getElementById('btnContinue').style.display = 'block';
			document.getElementById('btnContinue')
				.setAttribute('href', '/EPiServer/CMS/?language=sv#context=epi.cms.contentdata:///' +
				json.Root + '&viewsetting=viewlanguage:///sv');
		}

		out += '</table>';
		contentArea.innerHTML = out;
		contentArea.scrollTop = contentArea.scrollHeight;

		if (lastLogMessage.includes('Error')) {
			handleError();
		}
	}

	function getDateFromAspNetFormat(date) {
		var re = /-?\d+/;
		var m = re.exec(date);
		return new Date(parseInt(m[0], 10));
	}

	function start() {
		statusMessage.innerHTML = 'Starting...';
		fStatus = setInterval(checkStatus, 3000);
	}

	function stop() {
		setTimeout(function() {
			statusMessage.innerHTML = 'Done';
		}, 1500);

		clearInterval(fStatus);
	}

	function handleError() {
		setTimeout(function() {
			statusMessage.innerHTML = 'Error';
			document.querySelector('.report-generation__status-wrapper').classList.add('error');
			document.querySelector('.log-window table tr:last-of-type').classList.add('error');
		}, 1500);

		clearInterval(fStatus);
	}

	window.onload = function () {
		if (document.querySelector('.report-generation-page')) {
			start();
		}
	};
})();


